;(function ($) {
	$.ajax({
		url: '/wp-content/uploads/ahms_data/ardent_wait_times.json',
		cache: false,
		dataType: 'json',
	}).done(function (response) {
		if (Object.prototype.hasOwnProperty.call(response, 'departments')) {
			let departments = response.departments
			let er_departments = $('.er-waittime__location')
			er_departments.each(function () {
				let dept_id = $(this).data('departmentId')
				let department = departments.find(d => d.department_id === dept_id)
				if (department) {
					$($(this).find('.er-waittime__min')[0]).text(department.wait_time_minutes + ' mins')
				}
			})
		}
		if (Object.prototype.hasOwnProperty.call(response, 'timestamp')) {
			let updated_date = new Date(response.timestamp)
			$($.find('.er-waittime__updated')[0]).text(
				'Last update: ' +
					updated_date.toLocaleString('en-US', {
						day: 'numeric',
						year: 'numeric',
						month: 'numeric',
						hour: 'numeric',
						minute: 'numeric',
					})
			)
		}
	})
})(jQuery)
